import { ThemeDefinition } from 'vuetify';

export const chemistry: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#826AAF',
    'on-subject-original': '#FFFFFF',
    subject: '#7A60A9',
    'on-subject': '#FFFFFF',
    primary: '#644D8F',
    'on-primary': '#FFFFFF',
    'primary-container': '#D5CDE4',
    'on-primary-container': '#1C1528',
    secondary: '#5C5568',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D8D5DD',
    'on-secondary-container': '#1E1C22',
    surface: '#F9F7FC',
    'on-surface': '#1E1D20',
    'on-surface-medium': '#4B4950',
    'on-surface-low': '#97949E',
    outline: '#7E7986',
    'outline-variant': '#CBC9CF',
    'inverse-surface': '#2E2442',
    'inverse-on-surface': '#F1EEF6',
    'inverse-primary': '#C7BDDB',
    'surface-dim': '#D0C2EB',
    'surface-bright': '#FCFBFE',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F3F0FA',
    'surface-container': '#EDE8F7',
    'surface-container-high': '#E2D9F2',
    'surface-container-highest': '#DCD1F0',
  },
};

export const chemistryDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#826AAF',
    'on-subject-original': '#F9F7FC',
    subject: '#BBABD9',
    'on-subject': '#1B132A',
    primary: '#D4CAE7',
    'on-primary': '#1B132A',
    'primary-container': '#442F6A',
    'on-primary-container': '#F1EDF7',
    secondary: '#D2CDDA',
    'on-secondary': '#1D1A23',
    'secondary-container': '#494158',
    'on-secondary-container': '#F2F0F4',
    surface: '#131018',
    'on-surface': '#F2F2F3',
    'on-surface-medium': '#CBC9CF',
    'on-surface-low': '#7E7986',
    outline: '#98949E',
    'outline-variant': '#65616B',
    'inverse-surface': '#E3DEED',
    'inverse-on-surface': '#1C1528',
    'inverse-primary': '#2F2442',
    'surface-dim': '#110E15',
    'surface-bright': '#372F46',
    'surface-container-lowest': '#0E0C12',
    'surface-container-low': '#18151F',
    'surface-container': '#1F1B28',
    'surface-container-high': '#292334',
    'surface-container-highest': '#352D43',
  },
};
